export const COURSE_DOCUMENT_FILE_STATUS = {
  Generating: 1,
  SuccessfullyGenerated: 2,
  Failed: 3,
};
